import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import Playerholder3 from './Playerholder3.vue'

declareVconsoleComponent('playerholder3', Playerholder3, 'playerholder3:component')